import {
  GET_RESULTS_BEGIN,
  GET_RESULTS_SUCCESS,
  RESULTS_PAGE_LOAD
} from './results/results';

import {
  GET_ACCOUNT_SUCCESS,
  GET_TOKEN_BEGIN,
  GET_TOKEN_SUCCESS,
  UPDATE_USER_CLIENT_ID
} from './user/user';

import { HOME_PAGE_LOADED } from './home/home';
import { GET_CANONICAL_URLS, GET_META_DESCRIPTION } from './seo/seo';

import {
  GET_COUNTS_BEGIN,
  GET_COUNTS_SUCCESS,
  UPDATE_CRITERIA,
  UPDATE_ACTIVE_REFINEMENT
} from './search/search';

import { LAST_SEARCH_UPDATED } from './lastSearch/lastSearch';
import { GET_LMIS_BEGIN, GET_LMIS_SUCCESS } from './lmis/lmis';
import { LOCATION_CHANGED } from './location/location';
import { SAVED_JOBS_SEARCH_SUCCESS } from './savedJobs/savedJobs';
import { SHOW_IF_AVAILABLE } from './peekDown/peekDown';
import { GET_DASHBOARD_SUCCESS } from './dashboard/dashboard';

// These cannot be exported as POJOs because in causes circular
// dependencies and hence a race condition so using functions to access.
const transitions = {
  routeChange() {
    return {
      name: 'routeChange',
      allowedActions: [
        '@@REDUX_HOTJAR_QUEUE_TAGS',
        GET_ACCOUNT_SUCCESS,
        GET_CANONICAL_URLS,
        GET_COUNTS_BEGIN,
        GET_COUNTS_SUCCESS,
        GET_DASHBOARD_SUCCESS,
        GET_LMIS_BEGIN,
        GET_LMIS_SUCCESS,
        GET_META_DESCRIPTION,
        GET_RESULTS_BEGIN,
        GET_RESULTS_SUCCESS,
        GET_TOKEN_BEGIN,
        GET_TOKEN_SUCCESS,
        LAST_SEARCH_UPDATED,
        HOME_PAGE_LOADED,
        LOCATION_CHANGED,
        RESULTS_PAGE_LOAD,
        SAVED_JOBS_SEARCH_SUCCESS,
        SHOW_IF_AVAILABLE,
        UPDATE_CRITERIA,
        UPDATE_ACTIVE_REFINEMENT,
        UPDATE_USER_CLIENT_ID
      ]
    };
  }
};

export function getTransaction(transactionName) {
  const transitionFunc = transitions[transactionName];
  return transitionFunc();
}



/** WEBPACK FOOTER **
 ** ./app/store/transactions.js
 **/